import { useState } from 'react';
import './styles/SignIn.css';
import './Doorscanner'
import DoorScanner from './Doorscanner';

const SignIn = () => {
    const [step, setStep] = useState('checkEmail'); // checkEmail | resetPassword | login
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    // Simulated API call for checking if user exists
    const checkEmailAPI = async (email) => {
        // Replace this with real API
        return email === 'test@example.com'; // Simulates user exists
    };

    // Simulated API call for password reset
    const resetPasswordAPI = async (email) => {
        // Replace with real API call
        console.log('Password reset for:', email, password);
        return true;
    };

    // Simulated sign-in API
    const signInAPI = async (email, password) => {
        console.log('Signed in:', email, password);
        return true;
    };

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        const exists = await checkEmailAPI(email);
        if (exists) {
            setStep('resetPassword');
        } else {
            alert('Email not found new');
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (password.length < 6) {
            alert('Password must be at least 6 characters.');
            return;
        }
        if (password !== confirmPassword) {
            alert('Passwords do not match.');
            return;
        }
        const success = await resetPasswordAPI(email, password);
        if (success) {
            alert('Password reset successful. Please sign in.');
            setPassword('');
            setConfirmPassword('');
            setStep('login');
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            alert('Please enter email and password.');
            return;
        }
        const success = await signInAPI(email, password);
        if (success) {
            alert('Login successful!');
            // redirect or handle token etc.
        }
    };

    return (
        <div className="container">
            <h2>Heading</h2>

            {step === 'checkEmail' && (
                <form onSubmit={handleEmailSubmit}>
                    <h3>Enter Your Email</h3>
                    <input
                        type="email"
                        placeholder="Email"

                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit" className="signin-btn">Next</button>
                </form>



            )}

            {step === 'resetPassword' && (
                <form onSubmit={handleResetPassword}>
                    <h3>Reset Password</h3>
                    <input
                        type="password"
                        placeholder="New Password"

                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Confirm Password"

                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    <button type="submit" className="signin-btn">Reset Password</button>
                </form>
            )}

            {step === 'login' && (
                <form onSubmit={handleLogin}>
                    <h3>Sign In</h3>
                    <input
                        type="email"
                        placeholder="Email"

                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"

                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button type="submit" className="signin-btn">Sign In</button>
                </form>
            )}

            <DoorScanner/>
        </div>


    );
};

// const styles = {
//  container: {
//  width: '90%',
//  maxWidth: '400px',
//  margin: '60px auto',
//  padding: '20px',
//  borderRadius: '10px',
//  boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//  backgroundColor: 'hashtag#fff',
//  fontFamily: 'Segoe UI, sans-serif',
//  textAlign: 'center'
//  },
//  input: {
//  width: '100%',
//  padding: '12px',
//  margin: '10px 0',
//  borderRadius: '6px',
//  border: '1px solid hashtag#ccc',
//  fontSize: '1rem'
//  },
//  button: {
//  width: '100%',
//  padding: '12px',
//  backgroundColor: 'hashtag#28a745',
//  color: 'hashtag#fff',
//  border: 'none',
//  borderRadius: '6px',
//  cursor: 'pointer',
//  fontSize: '1rem'
//  }
// };

export default SignIn;



